import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faMapMarkerAlt, faCity, faStar, faGlobe, faBook, faBookOpen, faDownload, faGifts, faHandsHelping, faPhone, faRainbow, faShoppingCart, faStore, faVideo, faQrcode } from '@fortawesome/free-solid-svg-icons';
import './BookFusion.css';
import bookfusionimage from '../../assets/pageimages/BookFusion.webp';

function BookFusionHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-12 mx-8 border-b border-b-gray-300 text-white'>Think5Whys BookFusion</h2>
      </div>
      <div className="main-content">
        <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
            <div className="button-links flex align-middle justify-center bg-gray-500">
            <div className="bottom-buttons-box"><Link to="/bookfusion-mylist" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="bookfusion-bottomlink-style" />My List</Link></div>
            <div className="bottom-buttons-box"><Link to="/bookfusion-listpublishers" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="bookfusion-bottomlink-style" />Publisher's</Link></div>
            <div className="bottom-buttons-box"><Link to="/bookfusion-listbyinstitution" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="bookfusion-bottomlink-style" />Institution's</Link></div>
            <div className="bottom-buttons-box"><Link to="/bookfusion-practicetest" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="bookfusion-bottomlink-style" />Practice Test</Link></div>
            <div className="bottom-buttons-box"><Link to="/bookfusion-exam" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="bookfusion-bottomlink-style" />Exams</Link></div>
            <div className="bottom-buttons-box"><Link to="/bookfusion-certificates" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="bookfusion-bottomlink-style" />Certificates</Link></div>

          </div>
        </div>
        <div className="image-container">
          <div className="relative inset-0 flex border border-b-gray-300">
            <img id="bookfusion-id" src={bookfusionimage} alt="BookFusion Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default BookFusionHome;
